/** DGC Wallet / RWAX 下载链接（可由 stack-config → VITE_* 注入） */

function viteEnv(name: string, fallback: string): string {
	const v = import.meta.env[name];
	return typeof v === 'string' && v.length > 0 ? v : fallback;
}

/** 兼容旧 VITE；应用页不再展示 APK。 */
export const WALLET_APK_URL = viteEnv(
	'VITE_CPC_WALLET_APK_URL',
	'https://download.rwaxs.com/dgc-wallet.apk',
);

export const WALLET_APK_MIRROR_URL = viteEnv(
	'VITE_CPC_WALLET_APK_MIRROR_URL',
	'https://download.rwaxs.com/dgc-wallet.apk',
);

export const WALLET_EXTENSION_URL = viteEnv(
	'VITE_CPC_WALLET_EXTENSION_URL',
	'https://download.rwaxs.com/dgc-wallet-extension-dist.zip',
);

/** RWAX 超级 App — Android 主下载（手波安装页） */
export const RWAX_APP_URL = viteEnv(
	'VITE_RWAX_APP_URL',
	'https://app.shoubo.net/app.php/NA==',
);
